export default __webpack_public_path__ + "static/media/info-icon.1bcbf57d.svg";